export const paraFormatla = (sayi) => {
  return `${Number(sayi || 0).toLocaleString("tr-TR")} TL`;
};

export const yasHesapla = (dogumTarihi) => {
  if (!dogumTarihi) return "-";

  const d = new Date(dogumTarihi);
  const bugun = new Date();

  let yas = bugun.getFullYear() - d.getFullYear();
  const ayFarki = bugun.getMonth() - d.getMonth();

  if (ayFarki < 0 || (ayFarki === 0 && bugun.getDate() < d.getDate())) {
    yas--;
  }

  return yas;
};